import {useAppDispatch, useAppSelector} from "../../../redux/redux.hook";
import {selectAllServices, selectServiceById} from "./services.slice";
import React from "react";
import {changeServicePositionThunk, createServiceThunk, listServicesThunk, updateServiceThunk} from "./services.thunk";
import {ServiceDocumentData, UpdateServiceData} from "./types";

export function useInitializeServices() {
    const dispatch = useAppDispatch();
    React.useEffect(() => {
        dispatch(listServicesThunk());
    }, [dispatch]);
}

export function useServices() {
    return useAppSelector(selectAllServices);
}

export function useCreateService() {
    const dispatch = useAppDispatch();
    return {createService: (dto: ServiceDocumentData) => dispatch(createServiceThunk(dto))};
}

export function useUpdateService() {
    const dispatch = useAppDispatch();
    return {updateService: (id: string, dto: UpdateServiceData) => dispatch(updateServiceThunk({id, dto}))};
}

export function useUpdateServiceStatus() {
    const {updateService} = useUpdateService();
    return {updateServiceStatus: (id: string, active: boolean) => updateService(id, {active})}
}

export function useChangeServicePosition() {
    const dispatch = useAppDispatch();
    return {changeServicePosition: (id: string, variant: "increment" | "decrement") => dispatch(changeServicePositionThunk({id, variant}))};
}

export function useService(id: string) {
    const service = useAppSelector((state) => selectServiceById(state, id));
    const error = useAppSelector((state) => state.services.errors[id]);
    return {
        service,
        error
    }
}
